import { CreateActivityModel } from "@factory/model/query-model-activity";
import { UpdateActivityModel } from "@factory/model/query-model-activity";
import { DeleteActivityModel } from "@factory/model/query-model-activity";
import { CreateAgentModel } from "@factory/model/query-model-agent";
import { UpdateAgentModel } from "@factory/model/query-model-agent";
import { DeleteAgentModel } from "@factory/model/query-model-agent";
import { SigninAuthenticationModel } from "@factory/model/query-model-authentication";
import { CreateClientModel } from "@factory/model/query-model-client";
import { UpdateClientModel } from "@factory/model/query-model-client";
import { DeleteClientModel } from "@factory/model/query-model-client";
import { CreateHotelModel } from "@factory/model/query-model-hotel";
import { UpdateHotelModel } from "@factory/model/query-model-hotel";
import { DeleteHotelModel } from "@factory/model/query-model-hotel";
import { CreateInvoiceModel } from "@factory/model/query-model-invoice";
import { UpdateInvoiceModel } from "@factory/model/query-model-invoice";
import { DeleteInvoiceModel } from "@factory/model/query-model-invoice";
import { CreateLocationModel } from "@factory/model/query-model-location";
import { UpdateLocationModel } from "@factory/model/query-model-location";
import { DeleteLocationModel } from "@factory/model/query-model-location";
import { CreatePackageModel } from "@factory/model/query-model-package";
import { UpdatePackageModel } from "@factory/model/query-model-package";
import { DeletePackageModel } from "@factory/model/query-model-package";
import { CreatePackageAccommodationModel } from "@factory/model/query-model-package-accommodation";
import { UpdatePackageAccommodationModel } from "@factory/model/query-model-package-accommodation";
import { DeletePackageAccommodationModel } from "@factory/model/query-model-package-accommodation";
import { CreatePackageActivityModel } from "@factory/model/query-model-package-activity";
import { UpdatePackageActivityModel } from "@factory/model/query-model-package-activity";
import { DeletePackageActivityModel } from "@factory/model/query-model-package-activity";
import { CreatePackageTransportModel } from "@factory/model/query-model-package-transport";
import { UpdatePackageTransportModel } from "@factory/model/query-model-package-transport";
import { DeletePackageTransportModel } from "@factory/model/query-model-package-transport";
import { CreatePaymentModel } from "@factory/model/query-model-payment";
import { UpdatePaymentModel } from "@factory/model/query-model-payment";
import { DeletePaymentModel } from "@factory/model/query-model-payment";
import {
  CreatePersonModel,
  CreatePersonModelExtension,
  UpdatePersonModelExtension,
} from "@factory/model/query-model-person";
import { UpdatePersonModel } from "@factory/model/query-model-person";
import { DeletePersonModel } from "@factory/model/query-model-person";
import { CreateQuotationModel } from "@factory/model/query-model-quotation";
import { UpdateQuotationModel } from "@factory/model/query-model-quotation";
import { DeleteQuotationModel } from "@factory/model/query-model-quotation";
import { CreateQuoteAccommodationModel } from "@factory/model/query-model-quote-accommodation";
import { UpdateQuoteAccommodationModel } from "@factory/model/query-model-quote-accommodation";
import { DeleteQuoteAccommodationModel } from "@factory/model/query-model-quote-accommodation";
import { CreateQuoteActivityModel } from "@factory/model/query-model-quote-activity";
import { UpdateQuoteActivityModel } from "@factory/model/query-model-quote-activity";
import { DeleteQuoteActivityModel } from "@factory/model/query-model-quote-activity";
import { CreateQuoteTransportModel } from "@factory/model/query-model-quote-transport";
import { UpdateQuoteTransportModel } from "@factory/model/query-model-quote-transport";
import { DeleteQuoteTransportModel } from "@factory/model/query-model-quote-transport";
import { CreateRatePerPaxModel } from "@factory/model/query-model-rate-per-pax";
import { UpdateRatePerPaxModel } from "@factory/model/query-model-rate-per-pax";
import { DeleteRatePerPaxModel } from "@factory/model/query-model-rate-per-pax";
import { CreateRoleModel } from "@factory/model/query-model-role";
import { UpdateRoleModel } from "@factory/model/query-model-role";
import { DeleteRoleModel } from "@factory/model/query-model-role";
import { CreateRoomTypeModel } from "@factory/model/query-model-room-type";
import { UpdateRoomTypeModel } from "@factory/model/query-model-room-type";
import { DeleteRoomTypeModel } from "@factory/model/query-model-room-type";
import { CreateStatusModel } from "@factory/model/query-model-status";
import { UpdateStatusModel } from "@factory/model/query-model-status";
import { DeleteStatusModel } from "@factory/model/query-model-status";
import { CreateTenantModel } from "@factory/model/query-model-tenant";
import { UpdateTenantModel } from "@factory/model/query-model-tenant";
import { DeleteTenantModel } from "@factory/model/query-model-tenant";
import { CreateTransportTypeModel } from "@factory/model/query-model-transport-type";
import { UpdateTransportTypeModel } from "@factory/model/query-model-transport-type";
import { DeleteTransportTypeModel } from "@factory/model/query-model-transport-type";
import { CreateTravelVoucherModel } from "@factory/model/query-model-travel-voucher";
import { UpdateTravelVoucherModel } from "@factory/model/query-model-travel-voucher";
import { DeleteTravelVoucherModel } from "@factory/model/query-model-travel-voucher";
import { CreateUtilActivityTypeModel } from "@factory/model/query-model-util-activity-type";
import { UpdateUtilActivityTypeModel } from "@factory/model/query-model-util-activity-type";
import { DeleteUtilActivityTypeModel } from "@factory/model/query-model-util-activity-type";
import { CreateUtilAgeBracketModel } from "@factory/model/query-model-util-age-bracket";
import { UpdateUtilAgeBracketModel } from "@factory/model/query-model-util-age-bracket";
import { DeleteUtilAgeBracketModel } from "@factory/model/query-model-util-age-bracket";
import { CreateUtilTransportLocationModel } from "@factory/model/query-model-util-transport-location";
import { UpdateUtilTransportLocationModel } from "@factory/model/query-model-util-transport-location";
import { DeleteUtilTransportLocationModel } from "@factory/model/query-model-util-transport-location";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

// MAPPER QUERY MODEL IMPORT
import {
  ActivityFormSchema,
  AgentFormSchema,
  ClientFormSchema,
  HotelFormSchema,
  InvoiceFormSchema,
  LocationFormSchema,
  LoginFormSchema,
PackageAccommodationFormSchema,
  PackageActivityFormSchema,
  PackageFormSchema,
  PackageTransportFormSchema,
  PaymentFormSchema,
  PersonFormSchema,
  QuotationFormSchema,
  QuoteAccommodationFormSchema,
  QuoteActivityFormSchema,
  QuoteTransportFormSchema,
  RatePerPaxFormSchema,
  RoleFormSchema,
  RoomTypeFormSchema,
StatusFormSchema,
  TenantFormSchema,
  TransportTypeFormSchema,
  TravelVoucherFormSchema,
  UtilActivityTypeFormSchema,
UtilAgeBracketFormSchema,
  UtilTransportLocationFormSchema,
// MAPPER IMPORT
} from "../form/form.rule";

export function useFormApiMapper() {
  const { formatDate } = useDateTimeContext();

  const mapLogin = (form: LoginFormSchema) => {
    const payload = {
      username: form.username,
      password: form.password,
    } as SigninAuthenticationModel;

    return payload;
  };

  const mapCreateTenant = (form: TenantFormSchema) => {
    const payload = {
      owner: form.owner,
      slug: form.slug,
      business_name: form.businessName,
      business_type: form.businessType,
      description: form.description,
      avatar: form.avatar,
      email: form.email,
      mobile_number: form.mobileNumber,
      phone_number: form.phoneNumber,
      website: form.website,
      membership_date: formatDate(form.membershipDate as Date, undefined),
      rewards_type: form.rewardsType,
    } as CreateTenantModel;

    return payload;
  };
  const mapUpdateTenant = (form: TenantFormSchema, code: string) => {
    const payload = {
      code,
      owner: form.owner,
      slug: form.slug,
      business_name: form.businessName,
      business_type: form.businessType,
      description: form.description,
      avatar: form.avatar,
      email: form.email,
      mobile_number: form.mobileNumber,
      phone_number: form.phoneNumber,
      website: form.website,
      membership_date: formatDate(form.membershipDate as Date, undefined),
      rewards_type: form.rewardsType,
    } as UpdateTenantModel;

    return payload;
  };
  const mapDeleteTenant = (code: string) => {
    const payload = {
      code,
    } as DeleteTenantModel;

    return payload;
  };
  const mapCreateRole = (form: RoleFormSchema) => {
    const payload = {
      name: form.name,
      description: form.description,
    } as CreateRoleModel;

    return payload;
  };
  const mapUpdateRole = (form: RoleFormSchema, code: string) => {
    const payload = {
      code,
      name: form.name,
      description: form.description,
    } as UpdateRoleModel;

    return payload;
  };
  const mapDeleteRole = (code: string) => {
    const payload = {
      code,
    } as DeleteRoleModel;

    return payload;
  };
  const mapCreatePerson = (form: PersonFormSchema) => {
    const payload = {
      tenant: form.tenant,
      role: form.role,
      first_name: form.firstName,
      middle_name: form.middleName,
      last_name: form.lastName,
      username: form.username,
      email: form.email,
      password: form.password,
      is_verified: form.isVerified,
      avatar: form.avatar,
      activation_code: form.activationCode,
      gender: form.gender,
      birthday: formatDate(form.birthday as Date, undefined),
      is_blocked: form.isBlocked,
      mobile_number: form.mobileNumber,
      father_name: form.fatherName,
      mother_name: form.motherName,
      emergency_contact_1_number: form.emergencyContact_1Number,
      emergency_contact_1_name: form.emergencyContact_1Name,
      emergency_contact_1_relationship: form.emergencyContact_1Relationship,
      emergency_contact_2_number: form.emergencyContact_2Number,
      emergency_contact_2_name: form.emergencyContact_2Name,
      emergency_contact_2_relationship: form.emergencyContact_2Relationship,
      sss: form.sss,
      philhealth: form.philhealth,
      pagibig: form.pagibig,
      tin: form.tin,
      medical_condition: form.medicalCondition,
      blood_type: form.bloodType,
      elementary: form.elementary,
      high_school: form.highSchool,
      college: form.college,
      post_college: form.postCollege,
      undergraduate: form.undergraduate,
      curriculum_vitae: form.curriculumVitae,
      supporting_doc: form.supportingDoc,
      intent_letter: form.intentLetter,
      application_letter: form.applicationLetter,
    } as CreatePersonModel;

    const newPayload = {
      person: payload,
      file: form.photo,
    } as CreatePersonModelExtension;

    return newPayload;
  };
  const mapUpdatePerson = (form: PersonFormSchema, code: string) => {
    const payload = {
      code,
      tenant: form.tenant,
      role: form.role,
      first_name: form.firstName,
      middle_name: form.middleName,
      last_name: form.lastName,
      username: form.username,
      email: form.email,
      is_verified: form.isVerified,
      avatar: form.avatar,
      activation_code: form.activationCode,
      gender: form.gender,
      birthday: formatDate(form.birthday as Date, undefined),
      is_blocked: form.isBlocked,
      mobile_number: form.mobileNumber,
      father_name: form.fatherName,
      mother_name: form.motherName,
      emergency_contact_1_number: form.emergencyContact_1Number,
      emergency_contact_1_name: form.emergencyContact_1Name,
      emergency_contact_1_relationship: form.emergencyContact_1Relationship,
      emergency_contact_2_number: form.emergencyContact_2Number,
      emergency_contact_2_name: form.emergencyContact_2Name,
      emergency_contact_2_relationship: form.emergencyContact_2Relationship,
      sss: form.sss,
      philhealth: form.philhealth,
      pagibig: form.pagibig,
      tin: form.tin,
      medical_condition: form.medicalCondition,
      blood_type: form.bloodType,
      elementary: form.elementary,
      high_school: form.highSchool,
      college: form.college,
      post_college: form.postCollege,
      undergraduate: form.undergraduate,
      curriculum_vitae: form.curriculumVitae,
      supporting_doc: form.supportingDoc,
      intent_letter: form.intentLetter,
      application_letter: form.applicationLetter,
    } as UpdatePersonModel;

    if (form.password) {
      payload.password = form.password;
    }

    const newPayload = {
      person: payload,
      file: form.photo,
    } as UpdatePersonModelExtension;

    return newPayload;
  };
  const mapDeletePerson = (code: string) => {
    const payload = {
      code,
    } as DeletePersonModel;

    return payload;
  };
  const mapCreateTransportType = (form: TransportTypeFormSchema) => {
    const payload = {
      name: form.name,
      description: form.description,
    } as CreateTransportTypeModel;

    return payload;
  };
  const mapUpdateTransportType = (
    form: TransportTypeFormSchema,
    code: string
  ) => {
    const payload = {
      code,
      name: form.name,
      description: form.description,
    } as UpdateTransportTypeModel;

    return payload;
  };
  const mapDeleteTransportType = (code: string) => {
    const payload = {
      code,
    } as DeleteTransportTypeModel;

    return payload;
  };
  const mapCreateUtilTransportLocation = (
    form: UtilTransportLocationFormSchema
  ) => {
    const payload = {
      name: form.name,
      description: form.description,
    } as CreateUtilTransportLocationModel;

    return payload;
  };
  const mapUpdateUtilTransportLocation = (
    form: UtilTransportLocationFormSchema,
    code: string
  ) => {
    const payload = {
      code,
      name: form.name,
      description: form.description,
    } as UpdateUtilTransportLocationModel;

    return payload;
  };
  const mapDeleteUtilTransportLocation = (code: string) => {
    const payload = {
      code,
    } as DeleteUtilTransportLocationModel;

    return payload;
  };
  const mapCreateUtilActivityType = (form: UtilActivityTypeFormSchema) => {
    const payload = {
      name: form.name,
      description: form.description,
    } as CreateUtilActivityTypeModel;

    return payload;
  };
  const mapUpdateUtilActivityType = (
    form: UtilActivityTypeFormSchema,
    code: string
  ) => {
    const payload = {
      code,
      name: form.name,
      description: form.description,
    } as UpdateUtilActivityTypeModel;

    return payload;
  };
  const mapDeleteUtilActivityType = (code: string) => {
    const payload = {
      code,
    } as DeleteUtilActivityTypeModel;

    return payload;
  };
  const mapCreateLocation = (form: LocationFormSchema) => {
    const payload = {
      name: form.name,
      description: form.description,
    } as CreateLocationModel;

    return payload;
  };
  const mapUpdateLocation = (form: LocationFormSchema, code: string) => {
    const payload = {
      code,
      name: form.name,
      description: form.description,
    } as UpdateLocationModel;

    return payload;
  };
  const mapDeleteLocation = (code: string) => {
    const payload = {
      code,
    } as DeleteLocationModel;

    return payload;
  };
  const mapCreateClient = (form: ClientFormSchema) => {
    const payload = {
      name: form.name,
      email: form.email,
      address: form.address,
      city: form.city,
      province: form.province,
      contact_number: form.contactNumber,
    } as CreateClientModel;

    return payload;
  };
  const mapUpdateClient = (form: ClientFormSchema, code: string) => {
    const payload = {
      code,
      name: form.name,
      email: form.email,
      address: form.address,
      city: form.city,
      province: form.province,
      contact_number: form.contactNumber,
    } as UpdateClientModel;

    return payload;
  };
  const mapDeleteClient = (code: string) => {
    const payload = {
      code,
    } as DeleteClientModel;

    return payload;
  };
  const mapCreateAgent = (form: AgentFormSchema) => {
    const payload = {
      // code: form.code,
      name: form.name,
      email: form.email,
      address: form.address,
      contact_number: form.contactNumber,
      markup_percentage: form.markupPercentage,
    } as CreateAgentModel;

    return payload;
  };
  const mapUpdateAgent = (form: AgentFormSchema, code: string) => {
    const payload = {
      code: form.code,
      name: form.name,
      email: form.email,
      address: form.address,
      contact_number: form.contactNumber,
      markup_percentage: form.markupPercentage,
    } as UpdateAgentModel;

    return payload;
  };
  const mapDeleteAgent = (code: string) => {
    const payload = {
      code,
    } as DeleteAgentModel;

    return payload;
  };
  const mapCreateHotel = (form: HotelFormSchema) => {
    const payload = {
      code: form.code,
      name: form.name,
      with_breakfast: form.withBreakfast,
      location: form.location,
      description: form.description,
    } as CreateHotelModel;

    return payload;
  };
  const mapUpdateHotel = (form: HotelFormSchema, code: string) => {
    const payload = {
      code,
      name: form.name,
      with_breakfast: form.withBreakfast,
      location: form.location,
      description: form.description,
    } as UpdateHotelModel;

    return payload;
  };
  const mapDeleteHotel = (code: string) => {
    const payload = {
      code,
    } as DeleteHotelModel;

    return payload;
  };
  const mapCreateRoomType = (form: RoomTypeFormSchema) => {
    const payload = {
      hotel: form.hotel,
      valid_from: form.validFrom,
      valid_until: form.validUntil,
      name: form.name,
      price: form.price,
    } as CreateRoomTypeModel;

    return payload;
  };
  const mapUpdateRoomType = (form: RoomTypeFormSchema, code: string) => {
    const payload = {
      code,
      hotel: form.hotel,
      valid_from: form.validFrom,
      valid_until: form.validUntil,
      name: form.name,
      price: form.price,
    } as UpdateRoomTypeModel;

    return payload;
  };
  const mapDeleteRoomType = (code: string) => {
    const payload = {
      code,
    } as DeleteRoomTypeModel;

    return payload;
  };
  const mapCreateActivity = (form: ActivityFormSchema) => {
    const payload = {
      location: form.location,
      activity_type: form.activityType,
      name: form.name,
      description: form.description,
      is_child_activity: form.isChildActivity,
      child_rate: form.childRate,
      show_as_optional: form.showAsOptional,
      is_free: form.isFree,
      entrance_fee: form.entranceFee,
    } as CreateActivityModel;

    return payload;
  };
  const mapUpdateActivity = (form: ActivityFormSchema, code: string) => {
    const payload = {
      code,
      location: form.location,
      activity_type: form.activityType,
      name: form.name,
      description: form.description,
      is_child_activity: form.isChildActivity,
      child_rate: form.childRate,
      show_as_optional: form.showAsOptional,
      is_free: form.isFree,
      entrance_fee: form.entranceFee,
    } as UpdateActivityModel;

    return payload;
  };
  const mapDeleteActivity = (code: string) => {
    const payload = {
      code,
    } as DeleteActivityModel;

    return payload;
  };
  const mapCreatePackage = (form: PackageFormSchema) => {
    const payload = {
      name: form.name,
      num_people: form.numPeople,
      unit: form.unit,
      size_description: form.sizeDescription,
    } as CreatePackageModel;

    return payload;
  };
  const mapUpdatePackage = (form: PackageFormSchema, code: string) => {
    const payload = {
      code,
      name: form.name,
      num_people: form.numPeople,
      unit: form.unit,
      size_description: form.sizeDescription,
    } as UpdatePackageModel;

    return payload;
  };
  const mapDeletePackage = (code: string) => {
    const payload = {
      code,
    } as DeletePackageModel;

    return payload;
  };
  const mapCreateQuotation = (form: QuotationFormSchema) => {
    const payload = {
      base_package: form.basePackage,
      client: form.client,
      status: form.status,
      package_inclusions: form.packageInclusions,
      hide_total: form.hideTotal,
      custom_rows: form.customRows,
      custom_days: form.customDays,
      quotation_date: form.quotationDate,
      location: form.location,
      start_date: form.startDate,
      end_date: form.endDate,
      num_adults: form.numAdults,
      num_children: form.numChildren,
      num_nights: form.numNights,
      num_days: form.numDays,
      agent: form.agent,
      agent_markup: form.agentMarkup,
      adult_rate_total: form.adultRateTotal,
      child_rate_total: form.childRateTotal,
      amount: form.amount,
      activities: form.activities,
      transport: form.transport,
      accommodation: form.accommodation,
    } as CreateQuotationModel;

    return payload;
  };
  const mapUpdateQuotation = (form: QuotationFormSchema, code: string) => {
    const payload = {
      code,
      base_package: form.basePackage,
      client: form.client,
      status: form.status,
      package_inclusions: form.packageInclusions,
      hide_total: form.hideTotal,
      custom_rows: form.customRows,
      custom_days: form.customDays,
      quotation_date: form.quotationDate,
      location: form.location,
      start_date: form.startDate,
      end_date: form.endDate,
      num_adults: form.numAdults,
      num_children: form.numChildren,
      num_nights: form.numNights,
      num_days: form.numDays,
      agent: form.agent,
      agent_markup: form.agentMarkup,
      adult_rate_total: form.adultRateTotal,
      child_rate_total: form.childRateTotal,
      amount: form.amount,
      activities: form.activities,
      accommodation: form.accommodation,
      transport: form.transport,
    } as UpdateQuotationModel;

    return payload;
  };
  const mapDeleteQuotation = (code: string) => {
    const payload = {
      code,
    } as DeleteQuotationModel;

    return payload;
  };
  const mapCreateRatePerPax = (form: RatePerPaxFormSchema) => {
    const payload = {
      activity: form.activity,
      number: form.number,
      child_rate: form.childRate,
      // senior_rate: form.seniorRate,
      size_description: form.sizeDescription,
      amount: form.amount,
      total_amount: form.totalAmount,
    } as CreateRatePerPaxModel;

    return payload;
  };
  const mapUpdateRatePerPax = (form: RatePerPaxFormSchema, code: string) => {
    const payload = {
      code,
      activity: form.activity,
      number: form.number,
      size_description: form.sizeDescription,
      amount: form.amount,
      child_rate: form.childRate,
      // senior_rate: form.seniorRate,
      total_amount: form.totalAmount,
    } as UpdateRatePerPaxModel;

    return payload;
  };
  const mapDeleteRatePerPax = (code: string) => {
    const payload = {
      code,
    } as DeleteRatePerPaxModel;

    return payload;
  };
  const mapCreatePackageActivity = (form: PackageActivityFormSchema) => {
    const payload = {
      package: form.package,
      activity: form.activity,
    } as CreatePackageActivityModel;

    return payload;
  };
  const mapUpdatePackageActivity = (
    form: PackageActivityFormSchema,
    code: string
  ) => {
    const payload = {
      code,
      package: form.package,
      activity: form.activity,
    } as UpdatePackageActivityModel;

    return payload;
  };
  const mapDeletePackageActivity = (code: string) => {
    const payload = {
      code,
    } as DeletePackageActivityModel;

    return payload;
  };
  const mapCreateQuoteActivity = (form: QuoteActivityFormSchema) => {
    const payload = {
      base_activity: form.baseActivity,
      quotation: form.quotation,
      is_modified: form.isModified,
      name: form.name,
      description: form.description,
      day: form.day,
      is_child_activity: form.isChildActivity,
      child_rate: form.childRate,
      show_as_optional: form.showAsOptional,
      is_free: form.isFree,
      entrance_fee: form.entranceFee,
      num_people: form.numPeople,
      unit: form.unit,
    } as CreateQuoteActivityModel;

    return payload;
  };
  const mapUpdateQuoteActivity = (
    form: QuoteActivityFormSchema,
    code: string
  ) => {
    const payload = {
      code,
      base_activity: form.baseActivity,
      quotation: form.quotation,
      is_modified: form.isModified,
      name: form.name,
      description: form.description,
      day: form.day,
      is_child_activity: form.isChildActivity,
      child_rate: form.childRate,
      show_as_optional: form.showAsOptional,
      is_free: form.isFree,
      entrance_fee: form.entranceFee,
      num_people: form.numPeople,
      unit: form.unit,
    } as UpdateQuoteActivityModel;

    return payload;
  };
  const mapDeleteQuoteActivity = (code: string) => {
    const payload = {
      code,
    } as DeleteQuoteActivityModel;

    return payload;
  };
  const mapCreateQuoteTransport = (form: QuoteTransportFormSchema) => {
    const payload = {
      quotation: form.quotation,
      transport_type: form.transportType,
      from_location: form.fromLocation,
      to_location: form.toLocation,
      price_per_pax: form.pricePerPax,
      num_people: form.numPeople,
      unit: form.unit,
      amount: form.amount,
    } as CreateQuoteTransportModel;

    return payload;
  };
  const mapUpdateQuoteTransport = (
    form: QuoteTransportFormSchema,
    code: string
  ) => {
    const payload = {
      code,
      quotation: form.quotation,
      transport_type: form.transportType,
      from_location: form.fromLocation,
      to_location: form.toLocation,
      price_per_pax: form.pricePerPax,
      num_people: form.numPeople,
      unit: form.unit,
      amount: form.amount,
    } as UpdateQuoteTransportModel;

    return payload;
  };
  const mapDeleteQuoteTransport = (code: string) => {
    const payload = {
      code,
    } as DeleteQuoteTransportModel;

    return payload;
  };
  const mapCreateQuoteAccommodation = (form: QuoteAccommodationFormSchema) => {
    const payload = {
      quotation: form.quotation,
      hotel: form.hotel,
      room_type: form.roomType,
      num_people: form.numPeople,
      unit: form.unit,
      valid_from: form.validFrom,
      valid_until: form.validUntil,
      name: form.name,
      price: form.price,
      night: form.night,
    } as CreateQuoteAccommodationModel;

    return payload;
  };
  const mapUpdateQuoteAccommodation = (
    form: QuoteAccommodationFormSchema,
    code: string
  ) => {
    const payload = {
      code,
      quotation: form.quotation,
      hotel: form.hotel,
      room_type: form.roomType,
      num_people: form.numPeople,
      unit: form.unit,
      valid_from: form.validFrom,
      valid_until: form.validUntil,
      name: form.name,
      price: form.price,
    } as UpdateQuoteAccommodationModel;

    return payload;
  };
  const mapDeleteQuoteAccommodation = (code: string) => {
    const payload = {
      code,
    } as DeleteQuoteAccommodationModel;

    return payload;
  };
  const mapCreateInvoice = (form: InvoiceFormSchema) => {
    const payload = {
      base_quote: form.baseQuote,
      invoice_date: form.invoiceDate,
      due_date: form.dueDate,
      amount: form.amount,
    } as CreateInvoiceModel;

    return payload;
  };
  const mapUpdateInvoice = (form: InvoiceFormSchema, code: string) => {
    const payload = {
      code,
      base_quote: form.baseQuote,
      invoice_date: form.invoiceDate,
      due_date: form.dueDate,
      amount: form.amount,
    } as UpdateInvoiceModel;

    return payload;
  };
  const mapDeleteInvoice = (code: string) => {
    const payload = {
      code,
    } as DeleteInvoiceModel;

    return payload;
  };
  const mapCreateTravelVoucher = (form: TravelVoucherFormSchema) => {
    const payload = {
      base_invoice: form.baseInvoice,
      confirmation_num: form.confirmationNum,
      payment_completion: form.paymentCompletion,
      is_fully_paid: form.isFullyPaid,
      amount_paid: form.amountPaid,
      amount: form.amount,
    } as CreateTravelVoucherModel;

    return payload;
  };
  const mapUpdateTravelVoucher = (
    form: TravelVoucherFormSchema,
    code: string
  ) => {
    const payload = {
      code,
      base_invoice: form.baseInvoice,
      confirmation_num: form.confirmationNum,
      payment_completion: form.paymentCompletion,
      is_fully_paid: form.isFullyPaid,
      amount_paid: form.amountPaid,
      amount: form.amount,
    } as UpdateTravelVoucherModel;

    return payload;
  };
  const mapDeleteTravelVoucher = (code: string) => {
    const payload = {
      code,
    } as DeleteTravelVoucherModel;

    return payload;
  };
  const mapCreatePayment = (form: PaymentFormSchema) => {
    const payload = {
      voucher: form.voucher,
      description: form.description,
      payment_type: form.paymentType,
      payment_date: formatDate(form.paymentDate as Date, undefined),
      amount: form.amount,
    } as CreatePaymentModel;

    return payload;
  };
  const mapUpdatePayment = (form: PaymentFormSchema, code: string) => {
    const payload = {
      code,
      voucher: form.voucher,
      description: form.description,
      payment_type: form.paymentType,
      payment_date: formatDate(form.paymentDate as Date, undefined),
      amount: form.amount,
    } as UpdatePaymentModel;

    return payload;
  };
  const mapDeletePayment = (code: string) => {
    const payload = {
      code,
    } as DeletePaymentModel;

    return payload;
  };
  const mapCreatePackageTransport = (form: PackageTransportFormSchema) => {
		const payload = {
		package: form.package,
		transport: form.transport,
		transport_type: form.transportType,
		from_location: form.fromLocation,
		to_location: form.toLocation,
		price_per_pax: form.pricePerPax,
		num_people: form.numPeople,
		unit: form.unit,
		amount: form.amount,
		description: form.description,
		} as CreatePackageTransportModel;

		return payload;
	};
	const mapUpdatePackageTransport = (form: PackageTransportFormSchema, code: string) => {
		const payload = {
			code,
		package: form.package,
		transport: form.transport,
		transport_type: form.transportType,
		from_location: form.fromLocation,
		to_location: form.toLocation,
		price_per_pax: form.pricePerPax,
		num_people: form.numPeople,
		unit: form.unit,
		amount: form.amount,
		description: form.description,
		} as UpdatePackageTransportModel;

		return payload;
	};
	const mapDeletePackageTransport = (code: string) => {
		const payload = {
			code
		} as DeletePackageTransportModel;

		return payload;
	};
	const mapCreatePackageAccommodation = (form: PackageAccommodationFormSchema) => {
		const payload = {
		package: form.package,
		night: form.night,
		hotel: form.hotel,
		room_type: form.roomType,
		num_people: form.numPeople,
		unit: form.unit,
		valid_from: form.validFrom,
		valid_until: form.validUntil,
		name: form.name,
		price: form.price,
		description: form.description,
		} as CreatePackageAccommodationModel;

		return payload;
	};
	const mapUpdatePackageAccommodation = (form: PackageAccommodationFormSchema, code: string) => {
		const payload = {
			code,
		package: form.package,
		night: form.night,
		hotel: form.hotel,
		room_type: form.roomType,
		num_people: form.numPeople,
		unit: form.unit,
		valid_from: form.validFrom,
		valid_until: form.validUntil,
		name: form.name,
		price: form.price,
		description: form.description,
		} as UpdatePackageAccommodationModel;

		return payload;
	};
	const mapDeletePackageAccommodation = (code: string) => {
		const payload = {
			code
		} as DeletePackageAccommodationModel;

		return payload;
	};
	const mapCreateStatus = (form: StatusFormSchema) => {
		const payload = {
		name: form.name,
		description: form.description,
		} as CreateStatusModel;

		return payload;
	};
	const mapUpdateStatus = (form: StatusFormSchema, code: string) => {
		const payload = {
			code,
		name: form.name,
		description: form.description,
		} as UpdateStatusModel;

		return payload;
	};
	const mapDeleteStatus = (code: string) => {
		const payload = {
			code
		} as DeleteStatusModel;

		return payload;
	};
	const mapCreateUtilAgeBracket = (form: UtilAgeBracketFormSchema) => {
		const payload = {
		type: form.type,
		name: form.name,
		price: form.price,
		} as CreateUtilAgeBracketModel;

		return payload;
	};
	const mapUpdateUtilAgeBracket = (form: UtilAgeBracketFormSchema, code: string) => {
		const payload = {
			code,
		type: form.type,
		name: form.name,
		price: form.price,
		} as UpdateUtilAgeBracketModel;

		return payload;
	};
	const mapDeleteUtilAgeBracket = (code: string) => {
		const payload = {
			code
		} as DeleteUtilAgeBracketModel;

		return payload;
	};
	// MAPPER FUNCTION

  return {
    mapLogin,
    mapCreateTenant,
    mapUpdateTenant,
    mapDeleteTenant,
    mapCreateRole,
    mapUpdateRole,
    mapDeleteRole,
    mapCreatePerson,
    mapUpdatePerson,
    mapDeletePerson,
    mapCreateTransportType,
    mapUpdateTransportType,
    mapDeleteTransportType,
    mapCreateUtilTransportLocation,
    mapUpdateUtilTransportLocation,
    mapDeleteUtilTransportLocation,
    mapCreateUtilActivityType,
    mapUpdateUtilActivityType,
    mapDeleteUtilActivityType,
    mapCreateLocation,
    mapUpdateLocation,
    mapDeleteLocation,
    mapCreateClient,
    mapUpdateClient,
    mapDeleteClient,
    mapCreateAgent,
    mapUpdateAgent,
    mapDeleteAgent,
    mapCreateHotel,
    mapUpdateHotel,
    mapDeleteHotel,
    mapCreateRoomType,
    mapUpdateRoomType,
    mapDeleteRoomType,
    mapCreateActivity,
    mapUpdateActivity,
    mapDeleteActivity,
    mapCreatePackage,
    mapUpdatePackage,
    mapDeletePackage,
    mapCreateQuotation,
    mapUpdateQuotation,
    mapDeleteQuotation,
    mapCreateRatePerPax,
    mapUpdateRatePerPax,
    mapDeleteRatePerPax,
    mapCreatePackageActivity,
    mapUpdatePackageActivity,
    mapDeletePackageActivity,
    mapCreateQuoteActivity,
    mapUpdateQuoteActivity,
    mapDeleteQuoteActivity,
    mapCreateQuoteTransport,
    mapUpdateQuoteTransport,
    mapDeleteQuoteTransport,
    mapCreateQuoteAccommodation,
    mapUpdateQuoteAccommodation,
    mapDeleteQuoteAccommodation,
    mapCreateInvoice,
    mapUpdateInvoice,
    mapDeleteInvoice,
    mapCreateTravelVoucher,
    mapUpdateTravelVoucher,
    mapDeleteTravelVoucher,
    mapCreatePayment,
    mapUpdatePayment,
    mapDeletePayment,
    mapCreatePackageTransport,
mapUpdatePackageTransport,
mapDeletePackageTransport,
mapCreatePackageAccommodation,
mapUpdatePackageAccommodation,
mapDeletePackageAccommodation,
mapCreateStatus,
mapUpdateStatus,
mapDeleteStatus,
mapCreateUtilAgeBracket,
mapUpdateUtilAgeBracket,
mapDeleteUtilAgeBracket,
// MAPPER RETURN
  };
}
